import {
  Component,
  forwardRef,
  OnInit,
  input,
  viewChild,
  DestroyRef,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';

import { NG_VALUE_ACCESSOR, NgControl, FormsModule } from '@angular/forms';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ImmomioTooltipDirective } from '@immomio/ui/tooltip';
import { AppFormFieldControl } from '../../form-field/form-field-control/form-field-control';
import { BaseControl } from '../base-control';

@Component({
  selector: 'app-check',
  templateUrl: './check.component.html',
  styleUrls: ['./check.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckComponent),
      multi: true
    },
    {
      provide: AppFormFieldControl,
      useExisting: forwardRef(() => CheckComponent)
    }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ImmomioTooltipDirective, FormsModule]
})
export class CheckComponent extends BaseControl<boolean> implements OnInit {
  #destroyRef = inject(DestroyRef);
  readonly ngControl = viewChild(NgControl);
  readonly disableUncheck = input(false);
  readonly squared = input(false);
  readonly tooltip = input('');

  public ngOnInit() {
    this.ngControl()
      .statusChanges.pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(() => this.stateChanges.next());
  }

  public onClick(event: Event, value: boolean) {
    if (this.disableUncheck() && value) {
      event.preventDefault();
    }
  }
}
